import React from "react"

const ThrowError = ({ shouldThrowError }) => {
  if (shouldThrowError) {
      throw new Error("Mapbox failed to load");
    }
    return null;
}
export default ThrowError